import { publicPath } from "Constants/constants";

export const getAppPath = (): string => {
  return `${window.location.origin}/${publicPath}`;
};

export const getCartIdFromUrl = (): string => {
  const cartIdMatch = window.location.pathname.match(/\/(C-[-\w\d]+)/);
  return cartIdMatch ? cartIdMatch[1] : "";
};
